import React, { useState, Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import { ButtonToolbar, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { endOfYear, startOfYear } from 'date-fns';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';
import DateField from '../../../shared/components/form/DateField';
import YearField from '../../../shared/components/form/YearField';
import Select from '../../../shared/components/form/Select';

const SchoolTermForm = (props) => {
  const { t, backHandler, handleSubmit, dto, initialize, status } = props;
  const [isYearSelected, setIsYearSelected] = useState();
  const [startDayOfYear, setStartDayOfYear] = useState();
  const [endDayOfYear, setEndDayOfYear] = useState();
  const [selectedInitialDate, setSelectedInitialDate] = useState();
  const [selectedFinalDate, setSelectedFinalDate] = useState();

  const validateYearField = (yearField) => {
    setIsYearSelected(yearField);
  };

  const selectedDateYear = (selectedYear) => {
    setStartDayOfYear(startOfYear(selectedYear));
    setEndDayOfYear(endOfYear(selectedYear));
  };

  const onChangeSelectedInitialDate = (date) => {
    setSelectedInitialDate(date);
  };

  const onChangeSelectedFinalDate = (date) => {
    setSelectedFinalDate(date);
  };

  const initializeState = () => {
    const { year, initialDate, finalDate } = dto;
    if (year) {
      validateYearField(year);
    }
    if (year) {
      selectedDateYear(year);
    }
    if (initialDate) {
      setSelectedInitialDate(initialDate);
    }
    if (finalDate) {
      setSelectedFinalDate(finalDate);
    }
  };

  useEffect(() => {
    initialize(dto);
    initializeState();
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.name')}</span>
          <div className="form_form-group-field">
            <Field
              name="name"
              type="text"
              component={renderField}
              maxLength="50"
              placeholder={t('school-term.placeholders.name')}
            />
          </div>
        </div>
        <div className="form__form-group--3_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.year')}</span>
            <div className="form_form-group-field">
              <Field
                name="year"
                maxDate={new Date(9999, 12, 31)}
                component={YearField}
                placeholder={t('school-term.placeholders.year')}
                onChange={selectedDateYear}
                disabled={isYearSelected}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.initial_date')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="initialDate"
                maxDate={selectedFinalDate}
                minDate={startDayOfYear}
                disabled={!startDayOfYear}
                component={DateField}
                onChange={onChangeSelectedInitialDate}
                placeholder={t('school-term.placeholders.initial-date')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.final_date')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="finalDate"
                maxDate={endDayOfYear}
                minDate={selectedInitialDate}
                disabled={!selectedInitialDate}
                component={DateField}
                onChange={onChangeSelectedFinalDate}
                placeholder={t('school-term.placeholders.final-date')}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.status')}</span>
          <div className="form_form-group-field">
            <Field
              name="status"
              type="text"
              component={Select}
              options={status}
              placeholder={t('school-term.placeholders.status')}
            />
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

SchoolTermForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  status: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'SchoolTermForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(SchoolTermForm));
